import connector from 'api/http';
import { InsuranceName, MonthlyInstalment } from 'scenes/common/types';
import config from 'shared/config';

import { marshalMonthlyInstalment, unmarshalResponse } from './marshaller';

const monthlyinstalmentApi = (
  baseUrl: string = config.baseUrls.BFF_BASE_URL
) => {
  const server = connector(baseUrl);

  return {
    recalculateMonthlyInstalment: (
      insuranceName: InsuranceName,
      policyNumber: string,
      policyReference: string,
      paymentDate: string
    ): Promise<MonthlyInstalment> =>
      Promise.resolve()
        .then(() =>
          marshalMonthlyInstalment(
            insuranceName,
            policyNumber,
            policyReference,
            paymentDate
          )
        )
        .then((request) => server.post('/quote/monthlyinstalment', request))
        .then(unmarshalResponse),
  };
};

export default monthlyinstalmentApi;
